import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { selectors as ConfigSelectors } from 'data/config'
import logoColorSrc from 'assets/images/slite-app-round-logo.svg'
import { DlIcon, CheckboxIcon, CheckboxEmptyIcon } from 'components/Utils/Icons'
import { providesUserPreferencesMutations } from 'components/Settings/User/dataSync'
import { closeActiveModal } from 'data/ui/actions'

import { Text, Button } from 'components/base'

class DesktopRedirection extends React.Component {
  state = {
    alwaysOpenInBrowser: false,
  }

  handleOpenInBrowserClick = () => {
    if (this.state.alwaysOpenInBrowser) {
      this.props.updateUserPreferences({ isDesktopUser: false })
    }
    this.props.closeActiveModal()
  }
  render() {
    return (
      <div className="flexbox flexbox-column flexbox-align-center height-full-page flexbox-centered">
        <img
          src={logoColorSrc}
          width="100"
          alt="slite"
          className="margin-bottom-huge shadow-normal"
          style={{ borderRadius: 35 }}
        />
        <div className="margin-bottom-huge">
          <Text.Title className="margin-bottom-small">
            Opening the link in Slite app
          </Text.Title>
          <div className="shade-20 font-size-large">
            Hang on, you’re going to be redirected in few seconds...
          </div>
        </div>
        <div className="margin-bottom-normal background-shade-50 radius-normal flexbox flexbox-align-center padding-large">
          <Button.Secondary
            onClick={this.handleOpenInBrowserClick}
            className="margin-right-large"
          >
            Open in your browser
          </Button.Secondary>
          <Button.Primary
            onClick={() => window.open(this.props.desktopDownloadURL, '_blank')}
          >
            <DlIcon className="margin-right-small" size={12} />
            Download Slite app
          </Button.Primary>
        </div>
        <div className="shade-20 flexbox flexbox-align-center">
          <div
            onClick={() =>
              this.setState({
                alwaysOpenInBrowser: !this.state.alwaysOpenInBrowser,
              })
            }
            className="flexbox margin-right-smaller pointer"
          >
            {this.state.alwaysOpenInBrowser ? (
              <CheckboxIcon size={12} />
            ) : (
              <CheckboxEmptyIcon size={12} />
            )}
          </div>
          <div className="font-weight-medium">Always open in your browser</div>
        </div>
      </div>
    )
  }
}

export default compose(
  providesUserPreferencesMutations,
  connect(
    state => ({
      desktopDownloadURL: ConfigSelectors.getDesktopDownloadUrl(state),
    }),
    { closeActiveModal }
  )
)(DesktopRedirection)
